import {
  Component,
  computed,
  ElementRef,
  EventEmitter,
  input,
  Output,
  signal,
  ViewChild,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'infl-mobile-search-input',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './mobile-search-input.component.html',
  styleUrl: './mobile-search-input.component.scss',
})
export class MobileSearchInputComponent {
  public icon = input<string>('');
  public placeholder = input<string>('');

  protected currentValue = signal<string>('');

  protected displayClearIcon = computed(() => {
    return this.currentValue() !== '';
  });

  protected timeout: any;

  @ViewChild('input') input!: ElementRef<HTMLInputElement>;
  @Output() valueChange = new EventEmitter<string>();

  onBlur($event: FocusEvent) {
    this.sendEvent();
  }
  onKeyUp($event: KeyboardEvent) {
    this.currentValue.set(this.input.nativeElement.value);
    this.sendEvent();
  }

  private sendEvent(): void {
    clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      this.valueChange.emit(this.input.nativeElement.value);
    }, 100);
  }

  clear() {
    this.input.nativeElement.value = '';
    this.currentValue.set('');
    this.sendEvent();
  }
}
